import React, { useState, useEffect, useRef, useMemo } from 'react';
import { Container, Box, Button, Table, Grid } from '@mantine/core';
import { DatePicker } from '@mantine/dates';
import Select from 'react-select';
import { Scrollbars } from 'react-custom-scrollbars';
import { Calendar } from 'tabler-icons-react';
import { useLocation, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import moment from 'moment';
import _ from 'lodash';
import facilitiesFilter from './facilitesFilter';

// Custom Components
import Loader from '../../components/Loader/Loader';
import PageTitle from '../../components/PageTitle/PageTitle';
import Footer from '../../components/Footer/Footer';
import SchedulerModal from '../../components/modal/SchedulerModal';
import PaymentOptionModal from '../../components/modal/PaymentOptionModal';

// API-Services
import { complexBookingService, checkBookingService } from '../../service/api.service';

const AdvancedScheduler = () => {
    const divRef = useRef(null)
    const [layout, setLayout] = useState('fixed')
    const location = useLocation();
    const navigate = useNavigate();
    const { facilities, uuid, currency, complexImage, policy } = location.state;
    
    const newFacilities = facilitiesFilter(facilities)
    const [loading, setLoading] = useState(true);
    const [opened, setOpened] = useState(false);
    const [openedPaymentOptionModal, setOpenedPaymentOptionModal] = useState(false);

    const [selectedPaymentOption, setSelectedPaymentOption] = useState('full');
    const [bookingData, setBookingData] = useState({});
    const [bookingStartTime, setBookingStartTime] = useState(null);
    const [bookingAmPm, setBookingAmPm] = useState('AM');
    const [timeArray, setTimeArray] = useState([]);

    const [date, setDate] = useState(new Date());

    const [bookingDate, setBookingDate] = useState(new Date());
   const [id, setId] = useState(() => {
  const match = newFacilities.find((ele) =>
    ele.subCategory?.some((el) => el.id === location?.state?.id)
  );
  return match?.id ?? null;
});
    
    const [facilitiesTitle, setFacilitiesTitle] = useState(location?.state?.facilitiesTitle);
    const [fcId, setFcId] = useState(null)
    const [facility, setFacility] = useState({});
    const [courts, setCourts] = useState(location?.state?.courts);
    const [timeSlots, setTimeSlots] = useState(location?.state?.timeSlots);
    const [is30MinAllowed, setIs30MinAllowed] = useState(location?.state?.is30MinAllowed);
    const [timings, setTimings] = useState([]);
    const [maxBookingDays, setMaxBookingDays] = useState(0);
    const [duration, setDuration] = useState(); 
    const [checkedValue, setCheckedValue] = useState([]);

    let sortedTimings = [];
    let minMaxTime = [];

    
    const Timings = [];
    let minMaxT = '';
    if (typeof timings !== 'undefined') {
        for (let i = 0; i < timings.length; i += 1) {
            for (let j = 0; j < timings[i].prices.length; j += 1) {
                Timings.push({ ...timings[i].prices[j], days: timings[i].days });
            }
        }

        minMaxT = Timings.reduce((acc, val) => {
            acc[0] = acc[0] === undefined || val.start_time < acc[0].start_time ? val : acc[0];
            acc[1] = acc[1] === undefined || val.end_time > acc[1].end_time || val.end_time === '00:00' ? val : acc[1];
            return acc;
        }, []);
        sortedTimings = JSON.parse(JSON.stringify(Timings));
        minMaxTime = minMaxT;
    }

 const futureLimit = useMemo(() => {
  const d = new Date();
  d.setDate(d.getDate() + maxBookingDays);
  return d;
}, [maxBookingDays]);



    /**
     * @function isPassed
     * @params targetTime
     * @description check is booking time passed or not
    */

        const inMinutes = (stdTime) => {
            const [hours, minutes] = stdTime.split(":").map(Number);
            return hours * 60 + minutes;
        };

        function getZonedNow(timeZone) {
    const now = new Date();
    const parts = new Intl.DateTimeFormat("en-US", {
        timeZone,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
    }).formatToParts(now);

    const map = {};
    parts.forEach(({ type, value }) => {
        map[type] = value;
    });

    let hour = Number(map.hour);
    if (hour === 24) hour = 0; // some locales report midnight as "24"

    // Returns a Date whose Y/M/D/H/M/S numbers match the wall-clock
    // time in `timeZone` — treat it as a "naive" timestamp for comparison,
    // not as a real instant.
    return new Date(
        Number(map.year),
        Number(map.month) - 1,
        Number(map.day),
        hour,
        Number(map.minute),
        Number(map.second)
    );
}

function isPassed(targetTime) {
    const [startTime] = targetTime.split("-");
    const [referenceTime] = timeArray[0].split("-");

    const timeZone = localStorage.getItem("complexTimeZone") || "Asia/Kuala_Lumpur";

    // "now" expressed as KL wall-clock time
    const nowMY = getZonedNow(timeZone);

    // `date` is the slot's calendar date (e.g. "2026-08-06").
    const dateMY = new Date(date);

    const graceTime = 15;

    const year = dateMY.getFullYear();
    const month = dateMY.getMonth();
    const day = dateMY.getDate();

    const [h, m] = startTime.split(":").map(Number);
    const slotDateTime = new Date(year, month, day, h, m + graceTime, 0);

    // If reference time > slot start → push slot to next day
    if (inMinutes(referenceTime) > inMinutes(startTime)) {
        slotDateTime.setHours(slotDateTime.getHours() + 24);
    }

    return nowMY >= slotDateTime;
}

   /**
    * @function getSlotStatus 
    * @params timePassed bookedCourt
    * @description condition background of chart
    */

       function getSlotStatus(courtId, item, columnItem) {

         const passed = isPassed(item)
         const slotExists = bookingData[courtId]?.[item]?.[columnItem]

            if (slotExists === undefined) return null;
            if (passed) return 'Time Passed';
            if (!slotExists) return 'Booked';
            if (slotExists && !passed) return 'Available';
       return '';    
       }

    
    /**
     * @function getBackground
     * @params item columnItem
     * @description condition background of chart
    */
      
   const getBackground = (courtId, item, columnItem)=>{
    const timePassed = isPassed(item)
    const bookedCourt = bookingData[courtId]?.[item]?.[columnItem]
        if(timePassed===true || bookedCourt === undefined ){
            return 'gray'
        }   
        if(bookedCourt === false)
        {   
            return '#FA5000'
        }      
        return 'white'
    }    
    
    /**
     * @function hourConverter 
     * @params item
     * @description 
     */

    const hourConverter = (item) => {
        const [start, end] = item.split('-');

        const formatTime = (time) => {
            let [hour, minute] = time.split(':').map(Number);
            const suffix = hour >= 12 ? "PM" : "AM";

            // convert 24h → 12h
            hour = hour % 12 || 12;

            // pad with leading zeros
            const hh = hour.toString().padStart(2, "0");
            const mm = minute.toString().padStart(2, "0");

    return `${hh}:${mm} ${suffix}`;        
  };  
  return `${formatTime(start)} - ${formatTime(end)}`;
};  



    /**
     * @function makeBooking 
     * @params 
     * @description 
     */

    const makeBooking = () => {
       // if (facility?.subCategory?.length === 1) {
       //     setFcId(facility.subCategory[0].id);
       // } else {
       //     setFcId(null);
       // }
          setBookingStartTime(null);
          setTimings([])
          setOpened(true);
    }


      /**
     * @function resetFacilityDate
     * @params 
     * @description reset date and facility on closing of modal
     */
    

    const resetFacilityDate = () => {
        const newDate = new Date(date)
        setBookingDate(newDate);

          const maxDays = Math.max(
  ...(facility?.subCategory?.map(t => Number(t?.max_booking_days) || 0) || [0])
);
                setMaxBookingDays(maxDays)
    }
    
    
    /**
     * @function selectFacility
     * @params fc
     * @description
     */
    
    const selectFacility = (fc)=>{
        setFcId(fc?.id)
        setIs30MinAllowed(fc?.booking_window === '30.0');
        setMaxBookingDays(fc?.max_booking_days);
        setTimings(fc?.timings);
        setDuration(null);
    }
    
    /**
     * @function tdClick
     * @params event, item
     * @description
     */

   const tdClick = (event, item, is30MinAllowedFlag) => {
        event.stopPropagation();
        setOpened(true);

        // Parse slot times
        const [rawStart] = item.split('-');
        const startTime = rawStart;

        // Format using local time (not UTC)
        const timeMoment = moment(startTime, 'HH:mm');
        setBookingStartTime(timeMoment.format('hh:mm A'));
        setBookingAmPm(timeMoment.format('A'));

            const [referenceTime] = timeArray[0].split("-");

            if(inMinutes(referenceTime) > inMinutes(rawStart)){
               const newDate = new Date(date); // clone
                newDate.setDate(newDate.getDate() + 1);
                setBookingDate(newDate);
            }else{
                const newDate = new Date(date); // clone
                setBookingDate(newDate)
            }
};


    /**
     * @function getFacility
     * @params facilityId
     * @description used to Select Facility from id
     */

    function getFacility(facilityId) {
        const newFacility = newFacilities?.find((ele) => ele.id === facilityId || ele.subCategory.some((el) => el.id === facilityId));
        setFacility({ ...newFacility });
        return newFacility
    }

    /**
     * @function fetchBooking
     * @params
     * @description used to fetch booking
     */

    const fetchBooking = async () => {
        try {
            setLoading(true);
            // extracting all subCategories id's from newFacilities
            const arr = newFacilities
                .filter((ele) => ele.id === id || ele.subCategory.some((el) => el.id === id))
                .flatMap((ele) => ele.subCategory.map((el) => el.id));
            // getting all subCategories booking from api
            const timeObj = {}
            const allResult = await Promise.all(
                arr?.map(async (subId) => {
                    const result = await complexBookingService({
                        id: subId,
                        date: moment(date, 'DD-MM-YYYY').format('YYYY-MM-DD'),
                    });

                    if (result?.data?.success === 1) {
                        timeObj[subId] = result?.data.data
                        return { ...result.data.data };
                    }
                    // console.log(`Failed for subId ${subId}:`, result?.data?.message);
                    return null;
                })
            );


            // merging all Subcategories booking
            const result = allResult.reduce((acc, sum) => {
                Object.keys(sum).forEach((time) => {
                    if (acc[time]) {
                        acc[time] = { ...acc[time], ...sum[time] };
                    } else {
                        acc[time] = sum[time];
                    }
                });
                return acc;
            }, {});
            // merging all Subcategories booking

            if (result) {

                // setBookingData(result);
                 setBookingData(timeObj);

                const timingArray = Object.keys(result);
                const newFacility = getFacility(id);
                setCourts(newFacility?.subCategory?.flatMap((court) => court.courts));
                setTimeSlots(facilities?.find((item) => item?.id === id)?.timeSlots);
                setIs30MinAllowed(facilities?.find((item) => item?.id === id)?.booking_window === '30.0');
                setTimings(newFacility?.subCategory?.flatMap ((ele)=> ele?.timings));
            const maxDays = Math.max(
  ...(newFacility?.subCategory?.map(t => Number(t?.max_booking_days) || 0) || [0])
);
                setMaxBookingDays(maxDays)
                setTimeArray(timingArray);
                setLoading(false);
            } else {
                setLoading(false);
                Swal.fire({
                    title: 'Error!',
                    text: result?.data?.message || result?.response?.data?.message || 'Something went wrong',
                    icon: 'error',
                    confirmButtonText: 'Try Again',
                    confirmButtonColor: '#FA5000',
                });
            }
        } catch (error) {
            setLoading(false);
            Swal.fire({
                title: 'Error!',
                text: error || error?.response?.data?.message || 'Something went wrong',
                icon: 'error',
                confirmButtonText: 'Try Again',
                confirmButtonColor: '#FA5000',
            });
        }
    };

    
    // console.log(timeArray[0].split('-')[1].split(':')[0] <= 12)
    
    /**
     * @function convert12to24
     * @params
     * @description
    */
   const convert12to24 = () => {
       if (bookingStartTime?.split(' ')?.length === 1) {
           let [hours, minutes] = bookingStartTime.split(':');
           if (hours === '12') {
               hours = '00';
            }
            if (bookingAmPm === 'PM') {
                hours = parseInt(hours, 10) + 12;
            }
            return `${hours}:${minutes}`;
        }
        return moment(bookingStartTime, 'h:mm A').format('HH:mm');
    };
    
    
    /**
     * @function getAvailableCourts
     * @params
     * @description
    */
   const getAvailableCourts = (availableCourts) => {
       return availableCourts?.filter((item) => item?.available);
    };
    
    /**
     * @function calculateEndTime
     * @params
     * @description used to calculate end time
    */
   const calculateEndTime = () => {
       return moment(`${bookingStartTime} ${bookingAmPm}`, 'hh:mm A').add(duration, 'h').format('hh:mm A');
    };
    
    
    /**
     * @function proceedWithBooking
     * @params is_deposit
     * @description used to proceed with booking for make a booking flow
    */
   
   const proceedWithBooking = async (is_deposit) => {
       try {
           if (!checkedValue || !checkedValue.length) return;
           const result = await checkBookingService({
               sports_facility_id: fcId,
               // sports_facility_id: facility?.subCategory?.find((ele)=>ele?.id)?.id,
               date: moment(bookingDate, 'DD-MM-YYYY').format('YYYY-MM-DD'),
               start: convert12to24(),
               no_of_hours: Number(duration),
               court_nos: checkedValue,
               is_deposit,
            });
            if (result?.data?.success === 1) {
                navigate('/booking', {
                    state: {
                        sports_facility_id: fcId,
                        court_nos: checkedValue,
                        date: moment(bookingDate, 'DD-MM-YYYY').format('YYYY-MM-DD'),
                        start: convert12to24(),
                        no_of_hours: Number(duration),
                        total_expected_cost: result?.data?.data?.final_amount,
                        sports_name: result?.data?.data?.sports_facility?.name,
                        sports_thumb: result?.data?.data?.sports_facility?.images || [],
                        sports_end_time: calculateEndTime(),
                        sports_start_time: `${bookingStartTime}`,
                        sports_start_bookingAmPm: bookingAmPm,
                        uuid,
                        facilitiesTitle:facilities?.find((el)=> el?.id === fcId)?.name,
                        courts,
                        timeSlots,
                        id:fcId,
                        isLockedBookingValue: false,
                        booking: result?.data?.data,
                        complex: result?.data?.data?.sports_facility.sports_complex,
                        complexImage,
                    },
                });
            } else {
                Swal.fire({
                    title: 'Error!',
                    text: result?.data?.message || result?.response?.data?.message || 'Something went wrong',
                    icon: 'error',
                    confirmButtonText: 'Try Again',
                    confirmButtonColor: '#FA5000',
                });
            }
        } catch (error) {
            Swal.fire({
                title: 'Error!',
                text: error || error?.response?.data?.message || 'Something went wrong',
                icon: 'error',
                confirmButtonText: 'Try Again',
                confirmButtonColor: '#FA5000',
            });
        }
    };

    const w = window.innerHeight
    
    
    useEffect(() => {
        fetchBooking();
        const timeoutId = setTimeout(() => 3000);
        return function cleanup() {
            clearTimeout(timeoutId);
        };
    }, [date, id]);


   // updating the table layout 

    const MIN_COL_WIDTH = 120;

        useEffect(() => {
        const updateLayout = () => {
            const courtCount =
            facility?.subCategory?.reduce(
                (acc, fc) => acc + (fc?.courts?.length || 0),
                1
            ) ?? 0;

            const divWidth = divRef.current?.offsetWidth ?? 0;
            setLayout(courtCount * MIN_COL_WIDTH > divWidth ? "auto" : "fixed");
        };

        updateLayout();

        const observer = new ResizeObserver(updateLayout);
        if (divRef.current) observer.observe(divRef.current);

        return () => observer.disconnect();
        }, [facility]);


       const getFacilityName = (fName, fcName) => {
            if (fcName?.trim().includes(fName?.trim()) && fName?.trim() !== fcName?.trim()) {
                return fcName.replace(fName, "").trim();
            }
            return fcName?.trim();
        }


    return (
        <Container fluid className="px-0 min-vh-100 d-flex flex-column" size="md">
        <PageTitle uuid={uuid} logo={complexImage} />
        <Container fluid className="px-lg-5 w-100 mb-auto" size="md" px="md">
                {!uuid && (
                    <p
                        className="fs-40 fw-500 m-auto text-center"
                        style={{
                            color: '#ededed',
                        }}
                    >
                        Empty/Invalid UUID
                    </p>
                )}
                {uuid && loading ? (
                    <Loader />
                ) : (
                    <>
                        <Box
                            sx={() => ({
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                paddingBottom: '25px',
                                // border: '2px solid #EFEFEF',
                                background: 'white',
                                '@media (max-width: 600px)': {
                                    flexDirection: 'column',
                                    gap: 15,
                                },
                            })}
                        >
                            {id && facilitiesTitle && (
                                <Select
                                    placeholder="Select Facilities"
                                    className="w-xs-100"
                                    styles={{
                                        control: (baseStyles, state) => ({
                                            ...baseStyles,
                                            border: state.isFocused && '1px solid #FA5000',
                                            boxShadow: state.isFocused && '0px 0px 2px #FA5000',
                                            '&:hover': {
                                                border: '1px solid #FA5000',
                                                boxShadow: '0px 0px 2px #FA5000',
                                            },
                                        }),
                                       option: (styles, { isSelected, isFocused }) => ({
                                        ...styles,
                                        backgroundColor: (isSelected && '#FA5000') ||
                                                                                (isFocused && '#fa500055') ||
                                                                                'white',
                                        color: isSelected ? 'white' : '#FA5000',
                                        cursor: 'pointer',
                                        ':hover': !isSelected && {
                                            backgroundColor: '#fa500055',
                                            color: '#FA5000',
                                        },
                                        ':active': {
                                            backgroundColor: '#FA5000',
                                            color: 'white',
                                        },
                                        }),
                                    }}
                                    onChange={(value) => {
                                        setId(value?.value);
                                        setFacilitiesTitle(value?.label);
                                    }}
                                    options={newFacilities
                                        // ?.filter((item) => item.status === 1){/*  */}
                                        .map((item) => {
                                            return {
                                                value: item?.id,
                                                label: item?.name,
                                            };
                                        })}
                                    defaultValue={{
                                        value: facility?.id,
                                        label: facility?.name,
                                    }}
                                />
                            )}
                            <Box
                                className="flex-xs-wrap w-xs-100"
                                sx={() => ({
                                    display: 'flex',
                                    justifyContent: 'flex-end',
                                    '@media (max-width: 600px)': {
                                        marginTop: '5px',
                                        justifyContent: 'center',
                                    },
                                })}
                            >
                                <DatePicker
                                    placeholder="Pick date"
                                    minDate={new Date()}
                                    maxDate={futureLimit ?? undefined}
                                    value={date}
                                    onChange={(e) => {
                                        setDate(e);
                                        setBookingDate(e);
                                    }}
                                    clearable={false} 
                                    defaultValue={new Date()}
                                    icon={<Calendar className="text-dark" size={16} />}
                                    sx={() => ({
                                        '@media (max-width: 600px)': {
                                            width: '100%',
                                        },
                                        '@media (min-width: 600px)': {
                                            marginLeft: '1rem',
                                        }
                                    })}
                                />
                                <Button
                                    onClick={() => makeBooking()}
                                    sx={() => ({
                                        backgroundColor: '#FA5000',
                                        '&:hover': {
                                            backgroundColor: '#FA5000',
                                        },
                                        '@media (max-width: 600px)': {
                                            marginTop: '20px',
                                            justifyContent: 'center',
                                            width: '100%',
                                            marginLeft: 0,
                                        },
                                        '@media (min-width: 600px)': {
                                            marginLeft: '1rem',
                                        },
                                    })}
                                >
                                    + Make Booking
                                </Button>
                            </Box>
                        </Box>

                        <Scrollbars
                        
                            className="scheduler-table mb-3"
                            style={{height: '700px', position: 'relative',}}

                            autoHide={false}

                              renderThumbVertical={({ style, ...props }) => (
                                <div
                                    {...props}
                                    style={{
                                        ...style,
                                        border:'1px solid white',
                                        backgroundColor: '#FA5000', // Orange thumb
                                        borderRadius: '4px',
                                        width:'10px',
                                        zIndex: 10, // ensure thumb is above track
                                    }}
                                />
                            )}
                            renderThumbHorizontal={({ style, ...props }) => (
                                <div
                                    {...props}
                                    style={{
                                        ...style,
                                        border:'1px solid white',
                                        backgroundColor: '#FA5000', // Orange thumb
                                        borderRadius: '4px',
                                        height:'10px',
                                        zIndex: 10, // ensure thumb is above track
                                    }}
                                />
                            )}
                            renderTrackVertical={({ style, ...props }) => (
                                <div
                                    {...props}
                                    style={{
                                        ...style,
                                        background: '#0000001a', // blurred track
                                        borderRadius: '6px',
                                        width: '10px', // track width
                                        position: 'absolute',
                                        right: 1,
                                        top: 0,
                                        bottom: 0,
                                    }}
                                />
                            )}
                            renderTrackHorizontal={({ style, ...props }) => (
                                <div
                                    {...props}
                                    style={{
                                        ...style,
                                        background: '#0000001a',
                                        borderRadius: '6px',
                                        height: '10px', // track height
                                        position: 'absolute',
                                        left: 0,
                                        right: 0,
                                        bottom: 1,
                                    }}
                                />
                            )}
                        >
                            {/*   new Advanced Schedulare Feature Ended  */}
                            <Table
                             ref={divRef}
                                sx={() => ({
                                    // borderCollapse: 'collapse',
                                    borderCollapse: 'separate',
                                    borderSpacing: 0,
                                    
                                    tableLayout:layout,

                                     width: 'calc(100% + 1.5px)',
                                    
                                    '&.mantine-Table-root tr td:first-of-type': {
                                        position: 'sticky',
                                        width: '120px',
                                        left: 0,
                                        zIndex: 2,
                                    },
                                    '&.mantine-Table-root th:first-of-type': {
                                        position: 'sticky',
                                        width: '120px',
                                        left: 0,
                                        zIndex: 2,
                                    },
                                    '@media (max-width: 480px)': {
                                         tableLayout:'auto',
                                        '&.mantine-Table-root tr td:first-of-type': {
                                            width: '50px !important',
                                            padding: '7px !important',
                                            textAlign: 'center',
                                        },
                                        '&.mantine-Table-root th:first-of-type': {
                                            width: '50px !important',
                                            padding: '7px !important',
                                            textAlign: 'center',
                                        },
                                        '&.mantine-Table-root tr th': {
                                            minWidth: '50px !important',
                                            padding: '7px !important',
                                            textAlign: 'center',
                                        },
                                        '&.mantine-Table-root tr td': {
                                            minWidth: '50px !important',
                                            padding: '7px !important',
                                            textAlign: 'center',
                                        },
                                    },
                                })}
                            >
                                <thead
                                    style={{
                                          position: 'sticky', top: 0, zIndex:100}}
                                >
                                    {/* First row: Category headers */}
                                    <tr>
                                        <th
                                            aria-label="Category"
                                            style={{
                                                position: 'sticky',
                                                top: 0,
                                                padding: '0px',
                                                background: 'white',
                                                zIndex: 100,
                                            }}
                                        />
                                       
                                        {facility?.subCategory?.map((fc) => (
                                            <th
                                                key={fc.id}
                                                colSpan={fc.courts.length}
                                                style={{
                                                    padding: '0px 3px',
                                                    border: '1px solid #655d5b',
                                                    background: '#ffede6',
                                                    borderRadius:'5px 5px 0px 0px',
                                                    color: '#FA5000',
                                                    textAlign: 'center',
                                                    whiteSpace: 'nowrap',
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    maxWidth: '0', 
                                                }}
                                            >
                                               {getFacilityName(facility?.name, fc?.name)}
                                            </th>
                                        ))}
                                    </tr>

                                    <tr>
                                      <th
                                            style={{
                                                        padding: '15px',
                                                        border: '1px solid #EFEFEF',
                                                        background: '#EFEFEF',
                                                        color: '#121D22',
                                                        minWidth: '100px',
                                                        textAlign: 'center',
                                            }}
                                        >
                                            Court no.
                                        </th>
                                        {facility?.subCategory?.flatMap((court) =>court.courts?.map((courtName, index) => (
                                                <th
                                                    key={court.id+courtName}
                                                    style={{
                                                        padding: '15px',
                                                        // border: '0px solid #EFEFEF',
                                                        borderRight:court.courts.length === index+1 ? '1px solid #655d5b' : '1px solid #EFEFEF',
                                                        borderLeft:index === 0 ? '1px solid #655d5b' : '1px solid #EFEFEF',
                                                        background: '#EFEFEF',
                                                        color: '#121D22',
                                                         minWidth: '100px',
                                                        textAlign: 'center',
                                                    }}
                                                >
                                                    {courtName}
                                                </th>
                                            ))
                )}
                                    </tr>
                                </thead>

                                <tbody>
                                    {timeArray.map((item) => (
                                        <tr key={item} >
                                            {/* Time Column */}
                                            <td
                                                className="fw-bold"
                                                style={{
                                                    position: 'sticky',
                                                    top: 0,
                                                    padding: '15px',
                                                    border: '1px solid #EFEFEF',
                                                     background: 'white',
                                                    color: '#121D22',
                                                    minWidth: '130px',
                                                    zIndex: 99,
                                                }}
                                            >
                                                {
                                                   hourConverter(item)
                                                } 
                                            </td>

                                            {/* Court Cells */}
                                            {facility?.subCategory?.flatMap((court, subIndex) => court.courts?.map((columnItem, index) => (
                                                    <td
                                                        key={court.id + columnItem + item}
                                                        onClick={(event) => {
                                                            if (bookingData[court.id]?.[item]?.[columnItem] === true && !isPassed(item)){ 
                                                                const selectedFacility = facility?.subCategory[subIndex];
                                                                selectFacility(selectedFacility);
                                                                tdClick(event, item, selectedFacility.booking_window === "30.0");
                                                            }
                                                        }}
                                                        onKeyPress={() => true}
                                                        aria-label="Court"
                                                        role="button"
                                                        style={{
                                                            // color:'#d1d1d1',
                                                            color:'black',
                                                            padding: '15px',
                                                            border: '1px solid #EFEFEF',
                                                            borderRight:court.courts.length === index+1 ? '1px solid #655d5b' : '1px solid #EFEFEF',
                                                            borderLeft:index === 0 ? '1px solid #655d5b' : '1px solid #EFEFEF',
                                                            textAlign: 'center',
                                                            minWidth: '100px',
                                                            background: getBackground(court.id, item, columnItem),
                                                                // background: 
                                                                // bookingData[court.id]?.[item]?.[columnItem] === true ?
                                                                //   'white' : 
                                                                //   '#FA5000',
                                                        }}
                                                    >
                                                        {getSlotStatus(court.id, item,  columnItem)}
                                                    </td>
                                                ))
                                    )}
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>

                            {/*   new Advanced Schedulare Feature Ended  */}

                        </Scrollbars>
                
                    </>
                )}

                <SchedulerModal
                    courts={courts}
                    timeSlots={timeSlots}
                    timings={timings}
                    maxBookingDays={maxBookingDays}
                    bookingDate={bookingDate}
                    setBookingDate={setBookingDate}
                    bookingStartTime={bookingStartTime}
                    setBookingStartTime={setBookingStartTime}
                    bookingAmPm={bookingAmPm}
                    setBookingAmPm={setBookingAmPm}
                    is30MinAllowed={is30MinAllowed}
                    currency={currency}
                    // id={id}
                    id={fcId}
                    setFcId={setFcId}
                    uuid={uuid}
                    facility={facility}
                    facilities={facilities}
                    facilitiesTitle={facilities?.find((el)=> el?.id === fcId)?.name}
                    complexImage={complexImage}
                    duration={duration}
                    setDuration={setDuration}
                    checkedValue={checkedValue}
                    setCheckedValue={setCheckedValue}
                    convert12to24={convert12to24}
                    calculateEndTime={calculateEndTime}
                    opened={opened}
                    setOpened={setOpened}
                    setOpenedPaymentOptionModal={setOpenedPaymentOptionModal}
                    selectFacility = {selectFacility}
                    resetFacilityDate={resetFacilityDate}
                />

                <PaymentOptionModal
                    opened={openedPaymentOptionModal}
                    setOpened={setOpenedPaymentOptionModal}
                    selectedPaymentOption={selectedPaymentOption}
                    setSelectedPaymentOption={setSelectedPaymentOption}
                    proceedWithBooking={proceedWithBooking}
                />
            </Container>
            <Footer />
        </Container>
    );
};

export default AdvancedScheduler;
